import h from "axios";
import { useEventListener as E, useSyncedRef as T, useIntersectionObserver as g, useThrottledCallback as v } from "@react-hookz/web";
import { useState as c, useEffect as m, useCallback as S } from "react";
import { a as b } from "./index-DRvG3Okc.mjs";
const C = (s) => ({
  createUser: (n) => h.post(`${s}/email/login`, {
    ...n,
    create: 1,
    flow: 1,
    newsletterSubscribe: 1
  }, {
    headers: {
      "Content-Type": "application/json"
    },
    withCredentials: !0
  })
});
function G() {
  const [s, r] = c();
  return E(b(), "blur", () => {
    var n;
    typeof globalThis > "u" || r((n = document) === null || n === void 0 ? void 0 : n.activeElement);
  }), {
    activeElement: s
  };
}
const x = (s) => {
  const {
    ga4TrackingHandler: r,
    getGa4Event: n,
    options: e
  } = s, u = T(n), [a, d] = c(null), [p, l] = c(!1), o = e != null && e.shouldSendOnce ? !p : !0, t = g(o && u.current ? a : null, {
    threshold: e == null ? void 0 : e.intersectionThreshold
  }), f = v((i) => {
    e != null && e.isSendGA4Tracking && i && r && r(i), l(!0);
  }, [r, l], e != null && e.shouldThrottle ? 300 : 0, !0);
  return m(() => {
    !o || !(t != null && t.isIntersecting) || !u.current || f(u.current ? u.current() : null);
  }, [o, t == null ? void 0 : t.isIntersecting, f, u]), m(() => {
    l(!1);
  }, [a]), {
    captureTrackImpressionEventTargetElement: S((i) => {
      d(i);
    }, [d]),
    intersection: t
  };
};
export {
  G as a,
  x as b,
  C as u
};
//# sourceMappingURL=tracking-impression-event-CNbTJmA5.mjs.map
